/**
 * @fileoverview FRE-1328 — single source of truth for a thousands-separated
 * count string.
 *
 * These surfaces in the venue family hand-rolled this one-liner independently
 * (`VenueStatStrip`, `VenueTierShelf`, `VenueListCard`), plus two more in
 * `lib/venues/sliceCap` and
 * `VenuePagination`. Not one of them recorded WHY the locale is pinned, which
 * is the only non-obvious thing about the line — so every copy was one
 * "simplification" away from reintroducing the bug the pin exists to prevent.
 *
 * THE LOCALE IS PINNED ON PURPOSE. A bare `toLocaleString()` resolves the
 * runtime default, which can differ between the Node SSR render and the
 * browser (`1,234` vs `1.234` vs `1 234`). React then reports a hydration
 * mismatch on the digit separator — a defect that never reproduces on the
 * machine that shipped it. `en-US` is the app's own copy locale, so pinning it
 * is not a localisation regression: nothing here is translated yet.
 *
 * Lives alongside `formatEventCount` (WEB-831), which is the same lesson for
 * the `N EVENT(S)` fragment and now composes this helper rather than
 * repeating the pin.
 */

/**
 * Formats a count for display: `1234` → `"1,234"`, `47` → `"47"`.
 *
 * Callers own their own emptiness rules — this helper never decides that a
 * value is absent. A surface that must not render a zero or a non-finite
 * number guards before calling (see `VenueListCard`'s capacity badge).
 */
export function formatCount(value: number): string {
  return value.toLocaleString('en-US');
}
